import {Button} from 'shells/button/button';

import {VerificationState} from './consts';
import {getButtonLabel} from './helpers';

interface Props {
    verificationState: VerificationState;
    onSendTestEmail: () => Promise<void>;
    isSending: boolean;
}

export function SendTestEmailButton(props: Props) {
    const isBusy = props.isSending || props.verificationState === VerificationState.VERIFYING;

    return (
        <Button variant='secondary' size='big' onClick={props.onSendTestEmail} disabled={isBusy}>
            {getButtonLabel(props.verificationState, props.isSending)}
        </Button>
    );
}
